import { Injectable, signal, WritableSignal } from '@angular/core';
import { ILanguage } from '@models/cms/language';
import { ILoadResponse } from '@models/responses/load-response';
import { ISettings } from '@models/cms/settings';

@Injectable({
	providedIn: 'root',
})
export class CmsUtilsManagerService {
	languages: WritableSignal<ILanguage[]> = signal<ILanguage[]>([]);
	settings: WritableSignal<ISettings[]> = signal<ISettings[]>([]);

	settingsList: ISettings[] = [];

	private isLoaded: boolean = false;

	constructor() {
		this._init();
	}

	private _init(): void {
		if (!this.isLoaded) {
			this.fetchLanguages();
		}
	}

	/**
	 * Fetch languages - returns mock data since Rust API doesn't have this endpoint
	 */
	fetchLanguages(): void {
		// Return mock languages since Rust API doesn't have CMS endpoints
		const mockLanguages: ILanguage[] = [
			{ id: 1, language: 'English', short_code: 'en', active: true },
			{ id: 2, language: 'Polski', short_code: 'pl', active: true },
		];
		this.languages.set(mockLanguages);
		this.isLoaded = true;
	}

	/**
	 * Load settings - returns mock data since Rust API doesn't have this endpoint
	 */
	async loadSettings(): Promise<ILoadResponse> {
		// Return mock settings
		const mockSettings: ISettings[] = [
			{ id: 1, name: 'app_name', value: 'Cryptionis', active: true },
			{ id: 2, name: 'default_interval', value: '5', active: true },
		];

		this.settingsList = mockSettings;
		this.settings.set(mockSettings);

		return {
			loaded: true,
			message: '',
		};
	}

	getSettingsValueByName(name: string): ISettings | undefined {
		return this.settingsList.find((x) => x.name === name);
	}
}
